import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as reports from '../../../reports'
import type { Collection } from '../collection'
import type * as plugins from '../plugins'

/**
 * Copies the applied organization filter onto the reports collection, so the
 * generated report covers the same people the table shows.
 *
 * Reads the applied params rather than the apply action, because those params
 * are session-persisted: after a reload the table comes back filtered without
 * anything being applied again. Leading absences are skipped because the
 * reports collection's dimension-filter plugins are shared between reports.
 */
export const mirrorOrganizationFilterToReport = store.effects.create(
  (
    _feature: Collection['feature'],
    collection: Collection,
    organizationFilterPlugin: plugins.organizationDimensionFilter.Plugin,
    reportFilterPlugin: reports.plugins.organizationDimensionFilter.Plugin,
  ) =>
    collection.plugins.currentListPlugin.appliedParams.selectors.filters.asObservable.pipe(
      rxjs.map(filters =>
        organizationFilterPlugin.currentListFilter.get(filters),
      ),
      rxjs.skipWhile(filter => !filter),
      rxjs.distinctUntilChanged(isDeepEqual),
      rxjs.map(filter =>
        filter
          ? reportFilterPlugin.actions.setSelection
              .from(
                'Space.UnassignedSponsoredPeople.AppliedOrganizationFilter.Changed',
              )
              .create({
                entityId: filter.entityId,
                recordIds: filter.recordIds,
              })
          : reportFilterPlugin.actions.resetSelections
              .from(
                'Space.UnassignedSponsoredPeople.AppliedOrganizationFilter.Cleared',
              )
              .create(),
      ),
    ),
)
